export default "__VITE_ASSET__DOL5oImm__"